
import { track } from './posthog';

let url_api = process.env.REACT_APP_URL;

// Capture une erreur d'appel API (non-PII : endpoint + message technique uniquement).
function trackApiError(endpoint, error) {
  track('devis_erreur_api', {
    endpoint: endpoint,
    message: error && error.message ? error.message : String(error),
  });
}



function getURLAPI() {

  if(process.env.REACT_APP_URL == undefined) {
    return "https://app.phoner.co/api/module_devis"
  }else{
    return process.env.REACT_APP_URL;
  }


}




let API_URL = getURLAPI();

console.log("API_URL");
console.log(API_URL);

const categoryList = [
  {
    "IDCategorie" : "2",
    "IDPiece" : "4",
    "LibelleCategorie" : "Smartphone",
    "URL_IMG" : "//pro.phonerbusiness.com/ressources/images/devis_smartphone.png"
  },
  {
    "IDCategorie" : "1",
    "IDPiece" : "17",
    "LibelleCategorie" : "Tablette",
    "URL_IMG" : "//pro.phonerbusiness.com/ressources/images/devis_tablette.png"
  },
  {
    "IDCategorie" : "3",
    "IDPiece" : "10",
    "LibelleCategorie" : "Ordinateur",
    "URL_IMG" : "//pro.phonerbusiness.com/ressources/images/devis_macbook.png"
  },
  {
    "IDCategorie" : "4",
    "IDPiece" : "38",
    "LibelleCategorie" : "Objet connecté",
    "URL_IMG" : "//pro.phonerbusiness.com/ressources/images/devis_objet.png"
  }
];

const basicRequestOptions = {
  method: 'GET',
  headers: {'Authorization': 'Basic TG9naW5fRGV2aXNfQXV0aDM1OmZrMmRmZzV0bTAqRXJmaWUz'}
};

const devisRequestOptions = {
  method: 'POST',
  headers: {'Authorization': 'Basic TG9naW5fRGV2aXNfQXV0aDM1OmZrMmRmZzV0bTAqRXJmaWUz',
            'Content-Type': 'application/json'}
};





export default class APIUtilities {
  static generateCategoryList() {
    return categoryList;
  }


  static async generateCreneauList(GUID_Client) {

    let crenau_LIST = [];




    /*

    var phoneList = {"modele_LIST" : []};

    await fetch(API_URL+'/1/'+brandID+'/'+searchedText+'/modele', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        const otherPhone = {"IDModele": 0, "LibelleModele": "Autre", "URL_IMG": "//pro.phonerbusiness.com/ressources/images/modele_telephone.png"};
        phoneList = responseJson;
        phoneList.modele_LIST.push(otherPhone);
    })
    .catch(function(error) {
      console.log(error);
      trackApiError('modele', error);
    });
*/
    return crenau_LIST;
  }



  static async generateBrandList() {
    if(typeof(this.brandList) !== 'undefined')
      return this.brandList;

    await fetch(API_URL+'/1/marque', basicRequestOptions).then((response) => response.json())
      .then((responseJson) => {
        const otherBrand = {"IDMarque": 0, "LibelleMarque": "Autre", "Info" : "Autre",
                            "URL_IMG": "//pro.phonerbusiness.com/ressources/images/modele_telephoneV2.png"};
        responseJson.marque_LIST.push(otherBrand);
        this.brandList = responseJson;
      }).catch(function(error) {
        console.log(error);
        trackApiError('marque', error);
    });

    return this.brandList;
  }

  static async generateBrandListByPiece(IDPiece) {
    if(typeof(this.brandList) !== 'undefined')
      return this.brandList;

    await fetch(API_URL+'/1/'+ IDPiece +'/marqueV2', basicRequestOptions).then((response) => response.json())
      .then((responseJson) => {
        const otherBrand = {"IDMarque": 0, "LibelleMarque": "Autre", "Info" : "Autre",
                            "URL_IMG": "//pro.phonerbusiness.com/ressources/images/modele_telephoneV2.png"};
        responseJson.marque_LIST.push(otherBrand);
        this.brandList = responseJson;
      }).catch(function(error) {
        console.log(error);
        trackApiError('marque', error);
    });

    return this.brandList;
  }

  static async generatePhoneList(brandID, search) {
    var searchedText = search;
    if(searchedText.length === 0)
      searchedText = "-1";

    var phoneList = {"modele_LIST" : []};

    await fetch(API_URL+'/1/'+brandID+'/'+searchedText+'/modele', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        const otherPhone = {"IDModele": 0, "LibelleModele": "Autre", "URL_IMG": "//pro.phonerbusiness.com/ressources/images/modele_telephoneV2.png"};
        phoneList = responseJson;
        phoneList.modele_LIST.push(otherPhone);
    })
    .catch(function(error) {
      console.log(error);
      trackApiError('modele', error);
    });

    return phoneList;
  }

  static async generatePhoneListByPiece(brandID, IDPiece, search) {
    var searchedText = search;
    if(searchedText.length === 0)
      searchedText = "-1";

    var phoneList = {"modele_LIST" : []};

    await fetch(API_URL+'/1/'+brandID+'/' + IDPiece + '/' +searchedText+'/modeleV2', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        const otherPhone = {"IDModele": 0, "LibelleModele": "Autre", "URL_IMG": "//pro.phonerbusiness.com/ressources/images/modele_telephoneV2.png"};
        phoneList = responseJson;
        phoneList.modele_LIST.push(otherPhone);
    })
    .catch(function(error) {
      console.log(error);
      trackApiError('modele', error);
    });

    return phoneList;
  }

  // Paramétrage des remises du module devis (TICK00276, TICK00299, TICK00301) :
  // offre batterie, taux web et secondaire, montant minimum d'éligibilité,
  // bonus QualiRépar. Sert uniquement à l'AFFICHAGE : les remises réellement
  // enregistrées sont recalculées par le serveur à la création du devis.
  // Fail-safe : toute erreur (réseau, back indisponible) laisse les valeurs par
  // défaut, identiques à celles du backend.
  static async getParametrageOffres() {
    var parametrage = {
      active: false,
      pourcentage: 50,
      tauxWeb: 10,
      tauxSecondaire: 20,
      montantMin: 25,
      bonusQualiRepar: 25
    };

    await fetch(API_URL+'/parametrageOffres', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        if(responseJson && responseJson.parametrage) {
          var p = responseJson.parametrage;

          parametrage = {
            active: Number(p.IsOffreBatterieActive) === 1,
            pourcentage: Number(p.OffreBatteriePourcentage) > 0 ? Number(p.OffreBatteriePourcentage) : 50,
            tauxWeb: Number(p.RemiseWebPourcentage) > 0 ? Number(p.RemiseWebPourcentage) : 10,
            tauxSecondaire: Number(p.RemiseSecondairePourcentage) > 0 ? Number(p.RemiseSecondairePourcentage) : 20,
            montantMin: Number(p.MontantMinRemise) >= 0 ? Number(p.MontantMinRemise) : 25,
            bonusQualiRepar: Number(p.BonusQualiRepar) >= 0 ? Number(p.BonusQualiRepar) : 25
          };
        }
    })
    .catch(function(error) {
      console.log(error);
      trackApiError('parametrageOffres', error);
    });

    return parametrage;
  }

  // Vérifie un code promo auprès de l'API.
  // Retourne { valeur, estPourcentage } : valeur = montant en euros, ou taux de
  // remise quand estPourcentage vaut true. Retourne null quand le code est
  // inconnu, expiré, en sommeil, ou que l'appel échoue.
  //
  // Aucun filtre de longueur ici : la garde « moins de 4 caractères » déclarait
  // invalides, sans même appeler l'API, des codes réels de 3 caractères (SIG).
  // La validité est une décision du serveur.
  static async validatePromoCode(code) {
    const codeNettoye = String(code || '').trim();

    if(codeNettoye === '')
      return null;

    var resultat = null;

    // encodeURIComponent : le code est un segment d'URL. Sans lui, un code
    // contenant « / » (ETUDIANT/BDE) casse la route paramétrée et renvoie 404.
    await fetch(API_URL+'/'+encodeURIComponent(codeNettoye)+'/codepromo', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.montant != null) {
          // parseFloat, pas parseInt : un code à 14,99 € était annoncé « 14 € »
          // au client alors que 14,99 € étaient réellement appliqués.
          resultat = {
            valeur         : parseFloat(responseJson.montant.valeur) || 0,
            estPourcentage : Number(responseJson.montant.IsPourcentage) === 1
          };
        }
      })
      .catch(function(error) {
        console.log(error);
        trackApiError('codepromo', error);
    });

    return resultat;
  }

  // Récupère un devis existant pour ouverture directe sur l'étape prise de rendez-vous (lien SMS).
  // Renvoie le JSON du backend : { success, GUID_Client, IDSite, IsStockPieceDispo, reparation }.
  // Code inconnu => 404 avec { success:false } (fetch ne rejette pas sur 404, le corps est tout de même parsé).
  static async getDevisRDV(code) {
    let devisRDV = null;

    await fetch(API_URL+'/devis-rdv/'+code, basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        devisRDV = responseJson;
      })
      .catch(function(error) {
        console.log(error);
    });

    return devisRDV;
  }

  static sendPreDevis(GUID, selectedItems, campaign) {
    this.GUID = GUID;
    const tabTarif = this.getTabTarif(selectedItems);
    var raw = JSON.stringify({
      "IDSite" : 1,
      "GUID_Client" : GUID,
      "GUID_Campagne" : campaign,
      "TabTarif" : tabTarif
    });

    var requestOptions = devisRequestOptions;
    devisRequestOptions.body = raw;

    fetch(API_URL+'/addpreDevis', requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); trackApiError('addpreDevis', error); });
  }

  static async sendDevis(prenom, name, email, phone, site, GUID, items, details, promoCode, campaign) {
    const tabTarif = this.getTabTarif(items);


    let dateDevisRes = null;

    var raw = JSON.stringify({
      "Prenom" : prenom,
      "Nom" : name,
      "Email" : email,
      "Tel" : phone,
      "IDSite" : site,
      "GUID_Client" : GUID,
      "GUID_Campagne" : campaign,
      "TabTarif" : tabTarif,
      "MessageAutre" : details,
      "CodePromo" : promoCode
    });

    var requestOptions = devisRequestOptions;
    devisRequestOptions.body = raw;

    await fetch(API_URL+'/addDevis', requestOptions)
      .then(response => response.text())

      .then((responseJson) => {
        dateDevisRes = JSON.parse(responseJson);
      })



      .catch(error => { console.log('error', error); trackApiError('addDevis', error); });

      return dateDevisRes;
  }


  static async sendDemandeRDVDevis(GUID) {

    var raw = JSON.stringify({
      "GUID_Client" : GUID
    });

    var requestOptions = devisRequestOptions;
    devisRequestOptions.body = raw;

    await fetch(API_URL+'/addDemandeRDV_ModuleDevis', requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); trackApiError('addDemandeRDV_ModuleDevis', error); });
  }

  static async sendDemandeRDVDevisV2(GUID, pe_dateRDV) {


   
    var raw = JSON.stringify({
      "GUID_Client" : GUID,
      "DateRDV" : pe_dateRDV,
    });

    console.log(raw);

    var requestOptions = devisRequestOptions;
    devisRequestOptions.body = raw;

    await fetch(API_URL+'/addDemandeRDV_ModuleDevis', requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); trackApiError('addDemandeRDV_ModuleDevis', error); });
  }

  // IDSite : boutique choisie par le client. Elle était codée en dur à 1 (Vitré),
  // si bien que tout le monde se voyait proposer les horaires de Vitré.
  static async getTimeSlots(date, IDSite) {
    var day = date.getDate()+'';
    var month = parseInt(date.getMonth()+1)+'';

    day = day.length === 1 ? '0'+ day : day;
    month = month.length === 1 ? '0'+month : month;

    date = date.getFullYear() + '-' + month + '-' + day;
    var slotList = {"periode_LIST" : []};

    var IDSiteRequest = (IDSite > 0 ? IDSite : 1);

    await fetch(API_URL+'/'+IDSiteRequest+'/'+date+'/'+ this.GUID +'/periodeOuverture', basicRequestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        slotList = responseJson;
      })
      .catch(function(error) {
        console.log(error);
        trackApiError('periodeOuverture', error);
    });

    return slotList;
  }

  static getTabTarif(items) {
    if(items.length === 0)
      return [{"IDTarif" : 1648}];

    const tabTarif = items.map(item => {
      var newItem = {};
      newItem["IDTarif"] = item.IDArticle;
      return newItem;
    });

    return tabTarif;
  }

  static getCampaignId() {
    const params = window.location.search.split('campagne=');
    if(params.length > 1)
      return params[1].split('&')[0];

    return "";
  }
}
